module.exports = __webpack_public_path__ + "static/img/006.9e597eed.jpg";